export const usePDFDocumentModalStyles = () => {
    return {
      modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -48%)',
        width: '50vw',
        height: '88vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        paddingRight: '0px',
        paddingLeft: '0px',
        paddingTop: '1rem',
        outline: 'none',
        borderRadius: '1rem',
      },
      pdf: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '50vw',
        maxHeight: '88vh',
        width: '100%',
        height: '92%',
        overflowY: 'auto', 
        backgroundColor: 'white', 
      }
    }
}